<div class="meta-bar">
  <div class="container h-100">
    <div class="meta-bar__row">
      <div class="meta-bar__row__section">
        <div class="meta-bar__row__section__item" *ngFor="let item of metaMenu">
          <hdi-link
            [href]="item.url"
            [type]="LinkType.NOSTYLES"
            [label]="item.title"
            [hrefType]="
              item.url.startsWith('http') ||
              item.url.startsWith('www') ||
              item.url.startsWith('https')
                ? HrefType.EXTERNAL
                : HrefType.ANGULAR_ROUTE
            "
            [title]="item.hoverText || item.title"
            >{{ item.title }}</hdi-link
          >
        </div>
      </div>
    </div>
  </div>
</div>
